import React from "react";
// import {
//   Box,
//   TextField,
//   Grid,
//   FormControl,
//   FormLabel,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   Typography,
//   MenuItem
// } from "@mui/material";

const Section = ({ title, children }) => (
   <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm mb-6">
      <h3 className="text-lg font-bold text-gray-800 mb-4 pb-4 border-b border-gray-100">
         {title}
      </h3>
      {children}
   </div>
);

const RadioOption = ({ label, value, checked, onChange, name, description }) => (
   <label className={`flex items-start gap-3 p-3 rounded-xl border transition-all cursor-pointer ${checked ? "bg-green-50 border-green-200" : "bg-white border-gray-200 hover:bg-gray-50"}`}>
      <div className="flex items-center h-5 mt-0.5">
         <input
            type="radio"
            name={name}
            value={value}
            checked={checked}
            onChange={onChange}
            className="w-4 h-4 text-green-600 border-gray-300 focus:ring-green-500"
         />
      </div>
      <div className="flex-1">
         <span className={`block text-sm font-medium ${checked ? "text-green-900" : "text-gray-900"}`}>{label}</span>
         {description && <p className="text-xs text-gray-500 mt-0.5">{description}</p>}
      </div>
   </label>
);

const PaymentInfoForm = ({ formData, handleChange }) => {
   const InputClass = "bg-white border border-gray-200 text-gray-900 text-sm rounded-xl focus:ring-green-500 focus:border-green-500 block w-full p-2.5 outline-none transition-all shadow-sm";
   const LabelClass = "block mb-1.5 text-sm font-medium text-gray-700";

   return (
      <div className="max-w-6xl mx-auto">
         <Section title="บัญชีธนาคารสำหรับโอนเงิน">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
               <div>
                  <label className={LabelClass}>ชื่อบัญชี</label>
                  <input
                     type="text"
                     value={formData.bankAccountName || ""}
                     onChange={handleChange("bankAccountName")}
                     className={InputClass}
                  />
               </div>
               <div>
                  <label className={LabelClass}>ธนาคาร</label>
                  <select
                     value={formData.bankName || ""}
                     onChange={handleChange("bankName")}
                     className={InputClass}
                  >
                     <option value="">เลือกธนาคาร...</option>
                     {[
                        "กรุงเทพ",
                        "กสิกรไทย",
                        "กรุงไทย",
                        "กรุงศรีอยุธยา",
                        "ไทยพาณิชย์",
                        "ทหารไทยธนชาต",
                        "ยูโอบี",
                        "ซีไอเอ็มบีไทย",
                        "เกียรตินาคินภัทร",
                        "ออมสิน",
                        "ธ.ก.ส.",
                     ].map((bank) => (
                        <option key={bank} value={bank}>{bank}</option>
                     ))}
                  </select>
               </div>
               <div>
                  <label className={LabelClass}>เลขที่บัญชี</label>
                  <input
                     type="text"
                     value={formData.bankAccountNumber || ""}
                     onChange={handleChange("bankAccountNumber")}
                     className={InputClass}
                  />
               </div>
               <div>
                  <label className={LabelClass}>สาขา</label>
                  <input
                     type="text"
                     value={formData.bankBranch || ""}
                     onChange={handleChange("bankBranch")}
                     className={InputClass}
                  />
               </div>
            </div>
         </Section>

         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* การคำนวณภาษีซื้อ */}
            <Section title="การคำนวณภาษีซื้อ">
               <div className="space-y-2">
                  <RadioOption
                     name="purchaseTaxOption"
                     value="default"
                     checked={formData.purchaseTaxOption === "default"}
                     onChange={handleChange("purchaseTaxOption")}
                     label="ใช้ค่าเริ่มต้น (ไม่คำนวณภาษีมูลค่าเพิ่ม)"
                  />
                  <RadioOption
                     name="purchaseTaxOption"
                     value="noVat"
                     checked={formData.purchaseTaxOption === "noVat"}
                     onChange={handleChange("purchaseTaxOption")}
                     label="ไม่คำนวณภาษีมูลค่าเพิ่ม"
                  />
                  <RadioOption
                     name="purchaseTaxOption"
                     value="vatIncluded"
                     checked={formData.purchaseTaxOption === "vatIncluded"}
                     onChange={handleChange("purchaseTaxOption")}
                     label="ยอดรวมภาษีมูลค่าเพิ่มแล้ว"
                  />
                  <RadioOption
                     name="purchaseTaxOption"
                     value="vatExcluded"
                     checked={formData.purchaseTaxOption === "vatExcluded"}
                     onChange={handleChange("purchaseTaxOption")}
                     label="ยอดยังไม่รวมภาษีมูลค่าเพิ่ม"
                  />
               </div>
            </Section>

            {/* การคำนวณภาษีขาย */}
            <Section title="การคำนวณภาษีขาย">
               <div className="space-y-2">
                  <RadioOption
                     name="salesTaxOption"
                     value="default"
                     checked={formData.salesTaxOption === "default"}
                     onChange={handleChange("salesTaxOption")}
                     label="ใช้ค่าเริ่มต้น (ไม่คำนวณภาษีมูลค่าเพิ่ม)"
                  />
                  <RadioOption
                     name="salesTaxOption"
                     value="noVat"
                     checked={formData.salesTaxOption === "noVat"}
                     onChange={handleChange("salesTaxOption")}
                     label="ไม่คำนวณภาษีมูลค่าเพิ่ม"
                  />
                  <RadioOption
                     name="salesTaxOption"
                     value="vatIncluded"
                     checked={formData.salesTaxOption === "vatIncluded"}
                     onChange={handleChange("salesTaxOption")}
                     label="ยอดรวมภาษีมูลค่าเพิ่มแล้ว"
                  />
                  <RadioOption
                     name="salesTaxOption"
                     value="vatExcluded"
                     checked={formData.salesTaxOption === "vatExcluded"}
                     onChange={handleChange("salesTaxOption")}
                     label="ยอดยังไม่รวมภาษีมูลค่าเพิ่ม"
                  />
               </div>
            </Section>
         </div>

         {/* การปัดเศษจำนวน */}
         {/* <Section title="การปัดเศษจำนวน">
         <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
               <RadioOption
                  name="roundingOption"
                  value="none"
                  checked={formData.roundingOption === "none"}
                  onChange={handleChange("roundingOption")}
                  label="ไม่ปัดเศษ"
               />
               <RadioOption
                  name="roundingOption"
                  value="alwaysRound"
                  checked={formData.roundingOption === "alwaysRound"}
                  onChange={handleChange("roundingOption")}
                  label="ปัดเศษเสมอ"
               />
               <RadioOption
                  name="roundingOption"
                  value="never"
                  checked={formData.roundingOption === "never"}
                  onChange={handleChange("roundingOption")}
                  label="ปัดขึ้นเสมอ"
                  description="เช่น 1.01 ปัดขึ้นเป็น 2.00, 1.56 ปัดขึ้นเป็น 2.00"
               />
               <RadioOption
                  name="roundingOption"
                  value="whenGreaterOrEqual50"
                  checked={formData.roundingOption === "whenGreaterOrEqual50"}
                  onChange={handleChange("roundingOption")}
                  label="ปัดขึ้นเป็น 1 เมื่อตัวเลข >= 0.50 เท่านั้น"
                  description="เช่น 1.56 ปัดขึ้นเป็น 2.00, 1.49 ปัดลงเป็น 1.00"
               />
               <RadioOption
                  name="roundingOption"
                  value="between00and50"
                  checked={formData.roundingOption === "between00and50"}
                  onChange={handleChange("roundingOption")}
                  label="ปัดขั้น 0.50 เมื่อตัวเลข > 0.00 หรือ > 0.50"
                  description="เช่น 1.01 ปัดขึ้นเป็น 1.50, 1.78 ปัดขึ้นเป็น 2.00"
               />
               <RadioOption
                  name="roundingOption"
                  value="between025and075"
                  checked={formData.roundingOption === "between025and075"}
                  onChange={handleChange("roundingOption")}
                  label="ปัดขึ้น 0.50 เมื่อตัวเลข ≥ 0.25 หรือ ≥ 0.75"
                  description="เช่น 1.26 ปัดขึ้นเป็น 1.50, 1.78 ปัดขึ้นเป็น 2.00"
               />
               <RadioOption
                  name="roundingOption"
                  value="alwaysClose"
                  checked={formData.roundingOption === "alwaysClose"}
                  onChange={handleChange("roundingOption")}
                  label="ปัดลงเสมอ"
                  description="เช่น 1.56 ปัดลงเป็น 1.00, 1.01 ปัดลงเป็น 1.00"
               />
               <RadioOption
                  name="roundingOption"
                  value="lessThan100or050"
                  checked={formData.roundingOption === "lessThan100or050"}
                  onChange={handleChange("roundingOption")}
                  label="ปัดลง 0.50 เมื่อตัวเลข < 1.00 หรือ < 0.50"
                  description="เช่น 1.56 ปิดลงเป็น 1.50, 1.45 ปัดลงเป็น 1.00"
               />
         </div>
      </Section> */}
      </div>
   );
};

export default PaymentInfoForm;
